import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IInspectionItem from '../interfaces/IInspectionItem';
import Layout from '~/components/Layout';
import { useLang } from '~/hooks/useLang';
import { capitalizeFirstLetter } from '~/utils/strings';

export default function Create() {
  const { register, handleSubmit, control, setValue: setFormValue, watch } = useForm<IInspectionItem>();
  const { translate } = useLang();
  
  const nameValue = watch('name');
  React.useEffect(() => {
    if (nameValue) {
      const capitalized = capitalizeFirstLetter(nameValue);
      if (capitalized !== nameValue) {
        setFormValue('name', capitalized, { shouldValidate: false });
      }
    }
  }, [nameValue, setFormValue]);

  const fields = [
    { 
      name: 'name', 
      type: 'string', 
      required: true, 
      placeholder: translate('Inspection Item Name'),
    },
  ];

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        model="inspection-item"
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={translate('Inspection item created successfully!')}
        title={translate('Add Inspection Item')}
        subheader={translate('Add a new inspection item')}
        setFormValue={setFormValue}
        watch={watch}
      />
    </Layout>
  );
}